import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/es6.date.to-string";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.reflect.construct";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

import { __decorate } from "tslib";
import { Component, Vue } from 'nuxt-property-decorator';
import { ClientFactory } from "~/utils/api";
import { getModule } from "vuex-module-decorators";
import FilesModule from "~/store/files";

var MobileMenu = /*#__PURE__*/function (_Vue) {
  _inherits(MobileMenu, _Vue);

  var _super = _createSuper(MobileMenu);

  function MobileMenu() {
    var _this;

    _classCallCheck(this, MobileMenu);

    _this = _super.apply(this, arguments);
    _this.firstname = '';
    _this.lastname = '';
    _this.email = '';
    _this.permissions = {};
    _this.loading = true;
    _this.showEventFiles = true;
    return _this;
  }

  _createClass(MobileMenu, [{
    key: "initModules",
    value: function initModules() {
      this.filesModule = getModule(FilesModule, this.$store);
    }
  }, {
    key: "isAdmin",
    value: function isAdmin() {
      return this.$auth.user.permissions.isAdminUser;
    }
  }, {
    key: "created",
    value: function () {
      var _created = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                this.initModules();
                this.api = ClientFactory.createApiClient();
                this.api.deserialize = true;
                this.loading = false;

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function created() {
        return _created.apply(this, arguments);
      }

      return created;
    }()
  }, {
    key: "mounted",
    value: function mounted() {
      this.firstname = this.$store.$auth.user.data.firstname;
      this.lastname = this.$store.$auth.user.data.lastname;
      this.email = this.$store.$auth.user.data.email;
      this.permissions = Object.assign(this.permissions, this.$store.$auth.user.permissions);
    }
  }]);

  return MobileMenu;
}(Vue);

MobileMenu = __decorate([Component({})], MobileMenu);
export default MobileMenu;